import { Directive, ElementRef, Input } from '@angular/core';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Directive({
   selector: '[kendoTooltip]:[isTooltipVisible]',
})
export class TooltipDialogDirective {
   constructor(private tooltipDirective: TooltipDirective, private elementRef: ElementRef) {
      tooltipDirective.showOn = 'none';
   }

   @Input()
   public set isTooltipVisible(isVisible: boolean) {
      if (isVisible) {
         this.tooltipDirective.show(this.elementRef);
      } else {
         this.tooltipDirective.hide();
      }
   }

   @Input()
   public set tooltipTarget(elementRef: ElementRef) {
      this.elementRef = elementRef;
   }
}
